"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Logo_svg_1 = __importDefault(require("@/assets/Logo.svg"));
function Logo({ className = "", style }) {
    return (react_1.default.createElement("img", { src: Logo_svg_1.default, alt: "Braskem logo", className: className, style: style }));
}
exports.default = Logo;
